import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions } from './Shared';

const ReportJobChecksData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [scheduleDate, setScheduleDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied")
        }
    }

    const clearError = (e: any) => {
        var error = errors;
        delete error[e.target.name];
        setErrors(error);
    }

    const handleDateChange = (e: any) => {
        clearError(e);
        setScheduleDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!scheduleDate) {
            formIsValid = false;
            errorList["scheduleDate"] = "Schedule Date is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (validate()) {
            var url = "/report/JobChecks/" + scheduleDate + "/-1/-1/-1/-1";
            window.open(url, '_blank');
        }
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Job Arrival / Completion Checklist Report</h1>
            </div>
            <div className="marginTop20">
                <span>Select the Schedule Date to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="scheduleDate">
                    <span className="label">Schedule Date</span>
                    <input type='date' id="scheduleDate" name="scheduleDate" className='input' value={scheduleDate} onChange={(e) => handleDateChange(e)}></input>
                </label>
                <span className={errors["scheduleDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["scheduleDate"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportJobChecksData;